import { BaseModel } from 'ag-common-lib/lib/models/base.model';

export enum ProductionReconciliationMetricKey {
  submitted = 'submitted',
  paid = 'paid',
}

export const PRODUCTION_RECONCILIATION_METRIC_DEFINITIONS = [
  {
    key: ProductionReconciliationMetricKey.submitted,
    label: 'Submitted',
    format: 'currency' as const,
  },
  {
    key: ProductionReconciliationMetricKey.paid,
    label: 'Paid',
    format: 'currency' as const,
  },
];

export interface ProductionReconciliationCarrier {
  id: string;
  name: string;
}

export interface ProductionReconciliationCarrierMetrics {
  submitted: number;
  paid: number;
}

export enum ProductionReconciliationRecordKeys {
  year = 'year',
  week = 'week',
  range = 'range',
}

export interface ProductionReconciliationRecord extends BaseModel {
  [ProductionReconciliationRecordKeys.year]: number;
  [ProductionReconciliationRecordKeys.week]: number;
  [ProductionReconciliationRecordKeys.range]: string;
  [carrierId: string]: ProductionReconciliationCarrierMetrics | number | string | Date | boolean | undefined | null;
}
